import React, { useMemo } from 'react'
import { InputDate } from 'alurkerja-ui'
import moment from 'moment'

type EditDefaultDateProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditDefaultDate(props: EditDefaultDateProps) {
  const { index, element, currentElementState, setCurrentElementState } = props
  const isDateTime = useMemo(() => {
    return currentElementState.form_field_type === 'INPUT_DATETIME-LOCAL'
  }, [currentElementState])

  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{isDateTime ? 'Default Date Time' : 'Default Date'}</span>
      <InputDate
        onChange={(value) => {
          setCurrentElementState((prevState: any) => {
            return {
              ...prevState,
              [element]: value,
            }
          })
        }}
        size="sm"
        defaultValue={
          typeof currentElementState[element] === 'string' && currentElementState[element]
            ? moment(currentElementState[element]).isValid()
              ? moment(currentElementState[element]).toDate()
              : null
            : currentElementState[element] || null
        }
        dateFormat={currentElementState?.['format'] ?? 'dd/MM/yyyy'}
        timeFormat="HH:mm"
        showTimeInput={isDateTime}
        timeIntervals={5}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        isClearable
      />
    </div>
  )
}
